import { ErrorHelper } from '@/helpers/ErrorHelper'
import { mapState, mapGetters, mapActions } from 'vuex'
import { RecaptchaSettingsCacheMixin } from '../Booking/RecaptchaSettingsCacheMixin'
import { SelectedSiteIdMixin } from '../Booking/SelectedSiteIdMixin'

export const ClientRegistrationAddMixin = {
  mixins: [SelectedSiteIdMixin, RecaptchaSettingsCacheMixin],
  data () {
    return {
      error: '',
      recaptcha: '',
      recaptchaMessage: '',
      signatureData: '',
      signatureMessage: ''
    }
  },
  computed: {
    ...mapGetters('ClientRegistrationUpload', [
      'clientRegistrationModel'
    ]),
    ...mapState('ClientRegistration', [
      'addingClientRegistration',
      'contractTemplate'
    ]),
    ...mapState('ApplicationEvents', [
      'saveClientRegistrationEvent'
    ]),
    clientRegistrationAddModel () {
      return Object.assign({}, this.clientRegistrationModel, {
        recaptcha: this.recaptcha,
        signatureData: this.signatureData
      })
    },
    clientRegistrationAddModelValid () {
      return !!this.recaptchaValid && !!this.signatureValid
    },
    recaptchaValid () {
      return !this.recaptchaEnabled || !!this.clientRegistrationAddModel.recaptcha
    },
    signatureRequired () {
      return !!this.contractTemplate && !!this.contractTemplate.signatureRequired
    },
    signatureValid () {
      return !this.signatureRequired || !!this.signatureData
    }
  },
  watch: {
    saveClientRegistrationEvent () {
      this.validateRecaptcha()
      this.validateSignature()
    }
  },
  methods: {
    ...mapActions('ClientRegistration', [
      'addClientRegistration'
    ]),
    tryAddClientRegistration () {
      const self = this
      self.error = ''
      if (!self.clientRegistrationAddModelValid || !self.selectedSiteId) {
        return
      }
      self.addClientRegistration({ siteId: this.selectedSiteId, payload: self.clientRegistrationAddModel })
        .then(response => self.afterClientRegistrationAdded(response.data))
        .catch(error => { self.error = ErrorHelper.getError(error) })
    },
    afterClientRegistrationAdded () {
      // override if necessary
    },
    handleRecaptchaToken (token) {
      const self = this
      self.recaptcha = token
      self.validateRecaptcha()
    },
    handleRecaptchaError () {
      this.recaptcha = ''
    },
    validateRecaptcha () {
      this.recaptchaMessage = this.recaptchaValid ? '' : 'Please answer reCAPTCHA.'
    },
    validateSignature () {
      this.signatureMessage = this.signatureValid ? '' : 'Please sign the contract before submitting.'
    }
  }
}
